<template>
    
    <div >
        <regular-icon v-if="!tag" :file_name="file.name"/>
        <tag-icon v-else :file_id="file.id" />
    </div>
</template>

<script>
import RegularIcon from './RegularIcon.vue'
import TagIcon from './TagIcon.vue'

            // :class="[returnFileTypeColored(item.item) + '-tag']"
export default{
  components: { RegularIcon, TagIcon },
    props : {
        "file" : Object,
        "tag" : Boolean
    },
    mounted()
    {
        console.log("row file icon", this.file, this.tag)
    }
}
</script>


